
define('known/models/fantasyTeamModel',[
	'jquery',
	'underscore',
	'backbone',
	
	//Shims
	'backbone.relational'
], function($, _, Backbone){
	var FantasyTeam = Backbone.RelationalModel.extend({
		defaults: {
			id: null,
			leagueUserId: null,
			//leagueInstanceId: null,
			teamName: null,
			auctionBudget: null,
			draftPosition: null,
			notificationType: "NONE"
	    },
	    
	    urlRoot: function() {
	    	var lgId = this.lgId ? this.lgId : this.get("leagueInstanceId").get("leagueId");
	    	var lgInstId = this.lgInstId ? this.lgInstId : this.get("leagueInstanceId").get("id");
	    	
	    	return '/draftapp/leagues/' 
	    			+ lgId 
	    			+ '/league-instances/' 
	    			+ lgInstId 
	    			+ '/fantasy-teams/';
		},
	
		initialize: function(models, options) {
			if(options.lgInstId && options.lgId){
				this.lgInstId = options.lgInstId;
				this.lgId = options.lgId;
			}
	    },
	});
	
	return FantasyTeam;  
});